import { render, staticRenderFns } from "./NoWxClientTip.vue?vue&type=template&id=2c0df194&scoped=true&"
import script from "./NoWxClientTip.vue?vue&type=script&lang=js&"
export * from "./NoWxClientTip.vue?vue&type=script&lang=js&"
import style0 from "./NoWxClientTip.vue?vue&type=style&index=0&id=2c0df194&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0df194",
  null
  
)

export default component.exports